import request from "../services/requestService";
import { DASHBOARD } from "../constant";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";
import { modifyDashboardSummaryData } from "../container/Dashboard/dashboard.selector";

export const getDashboardSummary = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DASHBOARD_SUMMARY_START
    });
    return requestMethod(apiServices.getDashboardSummary(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;
        let modifiedSummaryData = modifyDashboardSummaryData(data);
        dispatch({
          type: DASHBOARD.DASHBOARD_SUMMARY_SUCCESS,
          payload: modifiedSummaryData
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DASHBOARD_SUMMARY_FAILURE
        });
      });
  };
};
export const showTeamSection = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DASHBOARD_TEAMSECTION_START
    });
    return requestMethod(apiServices.showTeamSection(params))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: DASHBOARD.DASHBOARD_TEAMSECTION_SUCCESS,
          payload: data
        });
        // return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DASHBOARD_TEAMSECTION_FAILURE
        });
      });
  };
};

export const getProjectsByScheme = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PROJECTS_BY_SCHEMES_START
    });
    return requestMethod(apiServices.getProjectsByScheme(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.PROJECTS_BY_SCHEMES_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_SCHEMES_FAILURE
        });
      });
  };
};

export const getIssuesByCategoryForGanttChart = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_START
    });
    return requestMethod(apiServices.getIssuesByCategoryForGanttChart(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.ISSUES_BY_CATEGORY_GANTT_CHART_FAILURE
        });
      });
  };
};

export const getIssuesByCategory = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.ISSUES_BY_CATEGORY_START
    });
    return requestMethod(apiServices.getIssuesByCategory(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.ISSUES_BY_CATEGORY_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.ISSUES_BY_CATEGORY_FAILURE
        });
      });
  };
};

export const getProjectsBy = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PROJECTS_BY_START
    });
    return requestMethod(apiServices.getProjectsBy(params))
      .then(resp => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_SUCCESS,
          payload: get(resp, "data.data")
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_FAILURE
        });
      });
  };
};

export const getProjectsByLocation = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PROJECTS_BY_LOCATION_START
    });
    return requestMethod(apiServices.getProjectsByLocation(params))
      .then(resp => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_LOCATION_SUCCESS,
          payload: get(resp, "data.data")
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_LOCATION_FAILURE
        });
      });
  };
};

export const getPendingIssuesBy = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.ISSUES_BY_START
    });
    return requestMethod(apiServices.getPendingIssuesBy(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.ISSUES_BY_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.ISSUES_BY_FAILURE
        });
      });
  };
};

export const getKanBanData = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.GET_KANBAN_START
    });
    return requestMethod(apiServices.getKanBanList())
      .then(resp => {
        dispatch({
          type: DASHBOARD.GET_KANBAN_SUCCESS,
          payload: {
            data: get(resp, "data.data"),
            status: get(resp, "data.status"),
            message: get(resp, "data.message")
          }
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.GET_KANBAN_FAILURE
        });
      });
  };
};

export const fetchMeetings = (requestMethod = request, date, data) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.FETCH_MEETINGS_START
    });
    return requestMethod(apiServices.fetchMeetings(date, data))
      .then(resp => {
        dispatch({
          type: DASHBOARD.FETCH_MEETINGS_SUCCESS,
          payload: {
            data: get(resp, "data.data"),
            status: get(resp, "data.status"),
            message: get(resp, "data.message")
          }
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.FETCH_MEETINGS_FAILURE
        });
      });
  };
};

export const getDashboardNotifications = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DASHBOARD_NOTIFICATION_START
    });
    return requestMethod(apiServices.getDashboardNotifications(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFICATION_SUCCESS,
          payload: data
        });
        return data ? get(data, "data.notifications") : [];
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFICATION_FAILURE
        });
      });
  };
};

export const getDashboardNotificationsViewed = (
  requestMethod = request,
  id
) => {
  return requestMethod(apiServices.getDashboardNotificationsViewed(id))
    .then(resp => {
      const { data } = resp;
      return data;
    })
    .catch(e => {
      console.log("", e.message);
    });
};

export const getDashboardNotificationsAllViewed = (
  requestMethod = request,
  workflowType
) => {
  return requestMethod(
    apiServices.getDashboardNotificationsAllViewed(workflowType)
  )
    .then(resp => {
      const { data } = resp;
      return data;
    })
    .catch(e => {
      console.log("", e.message);
    });
};

export const getNotificationsStatus = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_START
    });
    return requestMethod(apiServices.getNotificationsStatus(id))
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_FAILURE
        });
      });
  };
};

export const getNotificationUpdates = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_START
    });
    return requestMethod(apiServices.getNotificationUpdates())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DASHBOARD_NOTIFYSTATUS_UPDATES_FAILURE
        });
      });
  };
};

export const dashboardPendingTask = (requestMethod = request, params) => {
  return requestMethod(apiServices.dashboardPendingTaskParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("dashboard Pending Task Failed", e.message);
    });
};

export const PendingTaskResolvedComment = (requestMethod = request, params) => {
  return requestMethod(apiServices.PendingTaskResolvedCommentParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Resolved comment Failed", e.message);
    });
};

export const getKanbanList = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.GET_KANBAN_LIST_START
    });
    return requestMethod(apiServices.getKanbanList())
      .then(response => {
        dispatch({
          type: DASHBOARD.GET_KANBAN_LIST_SUCCESS,
          payload: get(response, "data")
        });
        return response;
      })
      .catch(e => {
        dispatch({
          type: DASHBOARD.GET_KANBAN_LIST_FAILURE
        });
      });
  };
};

export const getPragatiProjectList = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PROJECTS_BY_PRAGATI_START
    });
    return requestMethod(apiServices.getPragartiProjectsInfo(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.PROJECTS_BY_PRAGATI_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PROJECTS_BY_PRAGATI_FAILURE
        });
      });
  };
};

const getModifiedDelayedProjectData = data => {
  return (
    data &&
    data.length &&
    data.map((item, index) => {
      let projectData = item.projectData;
      projectData &&
        projectData.length &&
        projectData.map((val, idx) => {
          item[val.key] = val.projectCount;
        });
      return item;
    })
  );
};

export const getDelayedProjectsList = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.DELAYED_PROJECTS_START
    });
    return requestMethod(apiServices.getDelayedProjects(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        let modifiedData = getModifiedDelayedProjectData(data) || [];

        dispatch({
          type: DASHBOARD.DELAYED_PROJECTS_SUCCESS,
          payload: modifiedData
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.DELAYED_PROJECTS_FAILURE
        });
      });
  };
};

export const getProjectsCostOverRunList = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.COST_OVERRUN_PROJECTS_START
    });
    return requestMethod(apiServices.getCostOverrunProjects(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        let modifiedData = getModifiedDelayedProjectData(data) || [];

        dispatch({
          type: DASHBOARD.COST_OVERRUN_PROJECTS_SUCCESS,
          payload: modifiedData
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.COST_OVERRUN_PROJECTS_FAILURE
        });
      });
  };
};

export const getPmgMeetingStatusAction = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PMG_MEETING_STATUS_START
    });
    return requestMethod(apiServices.getPmgMeetingStatus(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.PMG_MEETING_STATUS_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PMG_MEETING_STATUS_FAILURE
        });
      });
  };
};

export const getDashboardUpcomingMeetings = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.GET_UPCOMING_MEETINGS_START
    });
    return requestMethod(apiServices.getDashboardUpcomingMettings(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.GET_UPCOMING_MEETINGS_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.GET_UPCOMING_MEETINGS_FAILURE
        });
      });
  };
};

export const getChildGroupIssuesData = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.GET_CHILD_ISSUE_START
    });
    return requestMethod(apiServices.getChildGroupIssuesData(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: DASHBOARD.GET_CHILD_ISSUE_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.GET_CHILD_ISSUE_FAILURE
        });
      });
  };
};

export const getDashboardPendingTasksAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD._START
    });
    return requestMethod(apiServices.getDashboardPendingTasks(params))
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: DASHBOARD._SUCCESS,
          payload: data
        });
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD._FAILURE
        });
      });
  };
};

export const getShowSponsorRecipientFilterAction = (
  requestMethod = request
) => {
  return requestMethod(apiServices.getShowSponsorRecipientFilterService())
    .then(resp => resp)
    .catch(err => err);
};

export const getShowStateAndCentralFilterAction = (requestMethod = request) => {
  return requestMethod(apiServices.getShowStateAndCentralFilterService())
    .then(resp => resp)
    .catch(err => err);
};

export const getWorkflowStatesAction = (requestMethod = request) => {
  return requestMethod(apiServices.getWorkflowStatesServices())
    .then(resp => resp)
    .catch(err => err);
};
